import { render } from "./ModalDefaultBrand.vue?vue&type=template&id=12a36534"
import script from "./ModalDefaultBrand.vue?vue&type=script&lang=js"
export * from "./ModalDefaultBrand.vue?vue&type=script&lang=js"

import "./ModalDefaultBrand.vue?vue&type=style&index=0&id=12a36534&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__